import J2VAuth from "./auth";

const APIHelper = {};

APIHelper.getTemplate = async function(templateID) {

    const userCredentials = J2VAuth.getCredentials();
    let headers = {};
    if (userCredentials) {
        headers = {
            "x-api-key": userCredentials.apiKey
        };
    }

    try {
        const response = await fetch(`https://api.json2video.com/v2/templates?id=${templateID}`, {
            method: "GET",
            headers: headers
        }).then((response) => response.json())
        .catch((error) => {
            console.log("getTemplate() exception: ", error);
            return null;
        });
        return response;
    }
    catch(error) {
        console.log(error);
        return null;
    }
}

APIHelper.saveTemplate = async function(templateId, templateJSON) {

    let url = "https://api.json2video.com/v2/templates";
    if (templateId) {
        url = `https://api.json2video.com/v2/templates?id=${templateId}`;
    }

    const userCredentials = J2VAuth.getCredentials();
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-api-key": userCredentials.apiKey
        },
        body: JSON.stringify(templateJSON)
    }).then((response) => response.json())
    .catch((error) => {
        console.log("saveTemplate() exception: ", error);
        return null;
    });
    
    return response;
}

export default APIHelper;